// extracted by mini-css-extract-plugin
export var highlightFade = "_2e-4";
export var highlighted = "_2e-3";
export var table = "_2e-1";
export var tableContainer = "_2e-0";
export var totalsRow = "_2e-2";